import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 15,
    type: CHECKLIST_ITEM_TYPE.OPEN_FOLLOW_UP,
    manifestKey: 'OPEN_FOLLOW_UP',

    try_it: {
        button_label: 'Open Follow-Up',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'OpenFollowUpCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { note: 'Follow-up completed — patient confirmed interest' },
        },
    },
    pre_flight_diff: [
        'Follow-up dialog opens — user adds a note',
        'Checklist item: PENDING → YES',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        'No lead status change',
        'Note: overlaps functionally with PHONE_CALLED but is a separate item type',
    ],
    has_step2_throttle: false,
    validation_laboratory: null,
};
